module.exports = __webpack_public_path__ + "static/media/HTML basics card.f96e5644.svg";